export class FileReaderUtils {
  public static read(file: File, callback: (result: string) => void): void {
    const reader = new FileReader();

    reader.readAsDataURL(file);
    reader.onload = (e: any) => callback(e.target.result);
  }
}
